import { atom } from "recoil"

export type FileConversionImage = {
    width: number;
    height: number;
    url: string;
}

export type FileConversion = {
  uuid: string
  status: "Waiting" | "Converting" | "Finished" | "Fail" | "Cancelled"
  convertedPercentage: number
  prefix: string
  pageCount: number
  images: FileConversionImage[]
  errorCode: string
  errorMessage: string
  spawnedInWhiteboard: boolean
}

export type FileConversions = {
  conversions: FileConversion[]
}

export const fileConversionsAtom = atom<FileConversions>({
  key: "fileConversionsAtom",
  default: {
    conversions: []
  },
 })
